export default __webpack_public_path__ + "static/media/lac_de_peyreguet.b2fe75f8.jpg";